import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Card, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios'; // Import Axios for making HTTP requests
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/style.enquiryform.css'; 

const VendorsArea = () => {
  const { t } = useTranslation();
    const navigate = useNavigate();
    const [form, setForm] = useState({
        username: '',
        password: ''
    });
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handleChange = (event) => {
        const { name, value } = event.target;
        setForm({
            ...form,
            [name]: value
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        
        console.log('Submitting login form:', form);

        try {
            const response = await axios.post('http://api.krushiratnamilk.com/login', {
                username: form.username,
                password: form.password
            });

            console.log('Login Response:', response);

            if (response.status === 200) {
                setSuccessMessage(t('Login successful!'));
                setErrorMessage('');
                navigate('/vendersDashboard');
            } else {
                setSuccessMessage('');
                setErrorMessage(t('Failed to login. Please check your credentials.'));
            }
        } catch (error) {
            console.error('Login Error:', error);
            setSuccessMessage('');
            setErrorMessage(t('Failed to login. Please check your credentials.'));
        }
    };

    const handleSignUp = () => {
        navigate('/signup');  // Redirect to signup page
    };

    return (
        <Container className="mt-5">
            <Row className="justify-content-md-center">
                <Col md={8}>
                    <Card className="shadow-lg p-4 enquiry-card">
                        <Card.Body>
                            <h1 className="text-center mb-4">{t('Vendor Login')}</h1>
                            <p className="text-center mb-4">{t('Sign in to access your vendor portal and manage fresh dairy orders.')}</p>
                            {successMessage && <Alert variant="success">{successMessage}</Alert>}
                            {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
                            <Form onSubmit={handleSubmit}>
                                <Form.Group controlId="formUsername" className="mb-3">
                                    <Form.Label>{t('Username')}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="username"
                                        value={form.username}
                                        onChange={handleChange}
                                        placeholder={t('Enter your username')}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group controlId="formPassword" className="mb-3">
                                    <Form.Label>{t('Password')}</Form.Label>
                                    <Form.Control
                                        type="password"
                                        name="password"
                                        value={form.password}
                                        onChange={handleChange}
                                        placeholder={t('Enter your password')}
                                        required
                                    />
                                </Form.Group>
                                <Button variant="primary" type="submit" className="w-100">
                                    {t('Login')}
                                </Button>
                            </Form>
                            <div className="signup-text mt-3 text-center">
                                <span>{t("Don't have an account?")} </span>
                                <button className="btn-signup" onClick={handleSignUp}>{t('Sign up')}</button>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default VendorsArea;